
import { ArticleData } from "../../../../articlePage/stateInterfaces"


interface Props {
    articleData: ArticleData;
}

interface State {
    open: boolean;
}

export class CalcalistArticleSummary extends React.Component<Props, State> {
 public static siteScriptName = "CalcalistArticleSummary"
 constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
}

private toggleSummary = () => {
        this.setState(prev => ({
            open: !prev.open
        }));
  };

public parseBodyToReact = (text: string): React.ReactNode => {
  if (!text) return null;
  const lines = text.split("\n").filter(l => l.trim());
  const items: React.ReactNode[] = [];
  lines.forEach((line, i) => {
    const isListItem = /^\s*(\*+|•|\.)\s*/.test(line);
    const cleanText = line
      .replace(/^\s*(\*+|•|\.)\s*/, "")
      .replace(/\*+/g, "")
      .trim();
    if (isListItem) {
      items.push(
        <li key={`li-${i}`} className="summaryListItem">
          {cleanText}
        </li>
      );
    } else {
      items.push(
        <p key={`p-${i}`} className="summarySmallText">
          {cleanText}
        </p>
      );
    }
  });
  return (
    <ul className="summaryList">
      {items}
    </ul>
  );
};

public render() {

    const { open } = this.state;
    const { summaryData } = this.props.articleData

    return (
      <div className={`calcalistArticleSummary ${this.state.open ? "open" : "closed"}`}>
        <button type="button"
          onClick={this.toggleSummary}
          className={`summaryBtn ${this.state.open ? "open" : "closed"}`}
        >
          <span className="summaryBtn-text">
           נקודות עיקריות
          </span>
          <span className="summaryBtn-plus">+</span>
          
        </button>

        {open && (
          <>
          <div className="summaryBox">
            {summaryData &&
                summaryData
                    .filter((item, i) => i === 0 || (item.title && item.body))
                    .map((item, i) => (
                    <div key={i} className={`summaryItem summaryItem-${i}`}>
                        {i !== 0 && <h3>{item.title}</h3>}
                        {this.parseBodyToReact(item.body)}
                    </div>
            ))}
           <div className="summarytxt">תוכן זה נוצר על ידי בינה מלאכותית</div>    
          </div>
          <div className="summaryBoxBottomBorder"></div>
          </> 
        )}

      </div>
    );
  }
}